export default __webpack_public_path__ + "static/media/React.3671031c.png";